import component from "./Button";
export default component;
